import { BUGUN } from "../config.js";
import { B, cls, staffOf } from "../domain/context.js";
import { card, classChip } from "../components/ui.js";
import { closeModal } from "../components/studentModal.js";
import { esc } from "../lib/fmt.js";
import { rerender } from "../lib/rerender.js";
import { routeFromHash } from "../router.js";
import { Personel } from "../repo/entities.js";
import { state } from "../state.js";
import { staffAvatar } from "../lib/avatar.js";

// ---------- PERSONEL ----------
// Görev listesi. sinifli olanlarda sınıf ataması yapılabilir; anaOgretmen
// olanlar sınıfın asıl öğretmeni olarak atanabilir.
export const PERSONEL_ROLLERI = [
  { label: "Sınıf Öğretmeni",         sinifli: true,  anaOgretmen: true },
  { label: "Yardımcı Öğretmen",       sinifli: true,  anaOgretmen: false },
  { label: "Aşçı",                    sinifli: false },
  { label: "Aşçı & Yardımcı",         sinifli: false },
  { label: "Servis Sorumlusu",        sinifli: false },
  { label: "Psikolog (yarı zamanlı)", sinifli: false },
  { label: "Şube Müdürü",             sinifli: false },
  { label: "Temizlik Görevlisi",      sinifli: false },
];

export const rolBilgisi = label => PERSONEL_ROLLERI.find(r => r.label === label);


export function viewPersonel() {
  const t = B();
  const aktif = t.staff.filter(p => p.status === "aktif").length;
  return `
  <div class="flex items-center justify-between gap-3 flex-wrap mb-4">
    <p class="text-sm text-inksoft">${t.staff.length} personel · ${aktif} aktif · ${t.staff.length - aktif} izinli</p>
    <button data-newstaff class="rounded-xl bg-ink text-white text-sm font-semibold px-4 py-2 hover:bg-inksoft transition">+ Yeni personel</button>
  </div>
  ${card(`
    <div class="overflow-x-auto">
      <table class="w-full text-sm min-w-[640px]">
        <thead>
          <tr class="text-left text-[11px] uppercase tracking-wide text-inksoft border-b border-line">
            <th class="px-5 py-3">Ad Soyad</th><th class="px-5 py-3">Görev</th><th class="px-5 py-3">Sınıf</th>
            <th class="px-5 py-3">Mesai</th><th class="px-5 py-3">Telefon</th><th class="px-5 py-3">Durum</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-line/70">
          ${t.staff.map(p => `
            <tr data-staff="${p.id}" class="hover:bg-paper/60 cursor-pointer">
              <td class="px-5 py-3 font-semibold whitespace-nowrap">
                <span class="inline-flex items-center gap-2.5">
                  ${staffAvatar(p, "w-8 h-8")}
                  <a href="#/personel/${p.id}" class="hover:underline decoration-grape decoration-2 underline-offset-4">${esc(p.name)}</a></span></td>
              <td class="px-5 py-3 text-inksoft whitespace-nowrap">${esc(p.role)}</td>
              <td class="px-5 py-3">${p.classId ? classChip(p.classId) : `<span class="text-inksoft/60">—</span>`}</td>
              <td class="px-5 py-3 text-inksoft whitespace-nowrap">${esc(p.shift)}</td>
              <td class="px-5 py-3 text-inksoft whitespace-nowrap">${esc(p.phone)}</td>
              <td class="px-5 py-3">${p.status === "aktif"
                ? `<span class="text-[11px] font-bold rounded-full bg-teal-soft text-teal px-2.5 py-1">Aktif</span>`
                : `<span class="text-[11px] font-bold rounded-full bg-sun-soft text-[#B07E14] px-2.5 py-1">İzinli</span>`}</td>
            </tr>`).join("")}
        </tbody>
      </table>
    </div>`)}`;
}

// ---------- YENİ PERSONEL FORMU ----------
/**
 * Personelin ünvanı serbest metin ("Aşçı", "Servis Sorumlusu"),
 * claim'deki rol ise kapalı bir küme. Eşleme scripts/seed.mjs
 * içindekiyle aynı mantık — ikisi ayrışırsa aynı kişi terminalden
 * ve arayüzden farklı rol alır.
 */
function davetRolu(unvan) {
  const u = (unvan ?? "").toLocaleLowerCase("tr");
  if (u.includes("müdür") || u.includes("mudur")) return "mudur";
  if (u.includes("aşçı") || u.includes("mutfak")) return "mutfak";
  if (u.includes("servis") || u.includes("şoför")) return "servis";
  return "egitmen";
}

export function openNewStaffForm() {
  const t = B();
  const varsayilanRol = PERSONEL_ROLLERI[0];

  document.getElementById("modalBox").innerHTML = `
    <div class="h-2.5 rounded-t-2xl bg-grape"></div>
    <div class="p-6">
      <div class="flex items-start justify-between gap-4">
        <h2 class="font-display font-bold text-xl">Yeni Personel</h2>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <p class="text-[11px] text-inksoft mt-1">${esc(t.name)} kadrosuna eklenir.</p>

      <div class="grid gap-3 sm:grid-cols-2 mt-4 text-sm">
        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Ad soyad</span>
          <input id="sName" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Örn. Elif Kandemir">
        </label>

        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Görev</span>
          <select id="sRole" class="w-full mt-1 rounded-xl border border-line px-3 py-2 bg-white">
            ${PERSONEL_ROLLERI.map(r => `<option>${esc(r.label)}</option>`).join("")}
          </select>
        </label>

        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Telefon</span>
          <input id="sPhone" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="0533 000 00 00">
        </label>

        <div id="sClassWrap" class="sm:col-span-2 ${varsayilanRol.sinifli ? "" : "hidden"}">
          <label class="block">
            <span class="text-[11px] font-bold text-inksoft uppercase">Sınıf</span>
            <select id="sClass" class="w-full mt-1 rounded-xl border border-line px-3 py-2 bg-white">
              <option value="">Sınıf atanmadı</option>
              ${t.classes.map(c => {
                const ogr = staffOf(c.teacherId);
                return `<option value="${c.id}">${esc(c.name)} · ${c.age}${ogr ? ` — şu an ${esc(ogr.name)}` : " — öğretmensiz"}</option>`;
              }).join("")}
            </select>
          </label>
          <label id="sPrimaryWrap" class="flex items-start gap-2 mt-2 text-xs cursor-pointer hidden">
            <input type="checkbox" id="sPrimary" class="mt-0.5 w-4 h-4 accent-grape shrink-0">
            <span>Sınıfın asıl öğretmeni yap — mevcut öğretmen yardımcı kadroya geçer.</span>
          </label>
        </div>

        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">Mesai</span>
          <input id="sShift" value="08:00–17:00" class="w-full mt-1 rounded-xl border border-line px-3 py-2">
        </label>

        <label class="block">
          <span class="text-[11px] font-bold text-inksoft uppercase">İşe başlama</span>
          <input id="sStart" type="date" value="${BUGUN}" class="w-full mt-1 rounded-xl border border-line px-3 py-2">
        </label>

        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">E-posta</span>
          <input id="sEmail" type="email" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="ornek@kurumunuz.com">
          <span class="block text-[10px] text-inksoft mt-1">
            Personelin uygulamaya gireceği adres. Google veya Apple hesabıyla
            aynı olmalı — davet bu adresle eşleşiyor.
          </span>
        </label>

        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Eğitim</span>
          <input id="sEdu" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Örn. Okul Öncesi Öğretmenliği — DAÜ">
        </label>

        <label class="block sm:col-span-2">
          <span class="text-[11px] font-bold text-inksoft uppercase">Belgeler</span>
          <input id="sCerts" class="w-full mt-1 rounded-xl border border-line px-3 py-2" placeholder="Virgülle ayırın: İlk Yardım (2026), Hijyen Belgesi">
        </label>
      </div>

      <div id="sError" class="hidden rounded-xl bg-coral-soft text-coral text-sm font-semibold px-3 py-2 mt-3"></div>

      <div class="flex gap-2 mt-4">
        <button id="sSave" class="flex-1 rounded-xl bg-teal text-white text-sm font-semibold px-4 py-2.5">Personeli kaydet</button>
        <button id="sCancel" class="rounded-xl border border-line text-sm font-semibold px-4 py-2.5">Vazgeç</button>
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;
  document.getElementById("sCancel").onclick = closeModal;

  const rolSelect = document.getElementById("sRole");
  const sinifKutu = document.getElementById("sClassWrap");
  const sinifSelect = document.getElementById("sClass");
  const anaKutu = document.getElementById("sPrimaryWrap");

  const alanlariGuncelle = () => {
    const r = rolBilgisi(rolSelect.value);
    sinifKutu.classList.toggle("hidden", !r?.sinifli);
    if (!r?.sinifli) sinifSelect.value = "";
    anaKutu.classList.toggle("hidden", !(r?.anaOgretmen && sinifSelect.value));
  };
  rolSelect.addEventListener("change", alanlariGuncelle);
  sinifSelect.addEventListener("change", alanlariGuncelle);

  document.getElementById("sSave").onclick = () => {
    const al = id => document.getElementById(id).value.trim();
    const hata = document.getElementById("sError");
    const eksik = [];
    if (!al("sName")) eksik.push("ad soyad");
    if (!al("sPhone")) eksik.push("telefon");
    if (!al("sStart")) eksik.push("işe başlama tarihi");
    if (eksik.length) {
      hata.textContent = `Şu alanlar gerekli: ${eksik.join(", ")}.`;
      hata.classList.remove("hidden");
      return;
    }

    const rol = rolSelect.value;
    const r = rolBilgisi(rol);
    const classId = r?.sinifli && sinifSelect.value ? sinifSelect.value : null;
    const kisi = {
      id: `personel-${Date.now()}`,
      name: al("sName"),
      role: rol,
      classId,
      phone: al("sPhone"),
      // E-posta UYDURULMAZ. Google/Apple girişinde davet bu adresle
      // eşleşiyor; addan türetilmiş sahte bir adres, kimsenin
      // giremeyeceği bir davet üretir. Ayrıca buradaki varsayılan
      // demo kiracısının alan adıydı ve her kreşe o yazılıyordu.
      email: al("sEmail").trim().toLowerCase(),
      shift: al("sShift") || "08:00–17:00",
      status: "aktif",
      startDate: al("sStart"),
      education: al("sEdu") || "—",
      certificates: al("sCerts").split(",").map(x => x.trim()).filter(Boolean),
    };

    Personel.ekle(state.branchId, kisi);

    // Personelin uygulamaya girebilmesi için DAVET gerekiyor; kayıt
    // tek başına yetmiyor. Davet başarısız olursa personel kaydı
    // yine de duruyor — yönetici Ayarlar → Davetler'den tekrar
    // deneyebilir. Kayıt eklemeyi davete bağlamak, ağ hatasında
    // personeli hiç eklenmemiş hâle düşürürdü.
    if (kisi.email) {
      import("../domain/firebase-auth.js")
        .then(m => m.davetEt({
          email: kisi.email,
          role: davetRolu(rol),
          branchId: state.branchId,
          name: kisi.name,
          classes: classId ? [classId] : [],
        }))
        .then(async () => {
          const { davetleriTazele } = await import("./davetler.js");
          davetleriTazele();
        })
        .catch(hata => console.warn(`Davet gönderilemedi (${kisi.email}):`, hata?.message));
    }

    // Asıl öğretmen olarak atanırsa sınıfın öğretmeni değişir; öncekinin
    // sınıf bağı korunur, yardımcı kadroda görünür.
    if (classId && document.getElementById("sPrimary")?.checked) {
      Personel.sinifOgretmeniAta(state.branchId, cls(classId), kisi);
    }

    closeModal();
    location.hash = `#/personel/${kisi.id}`;
    routeFromHash();
    rerender();
  };
}

